import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeletePortalFormerName = () => {
  const { authHeader } = useAuth();
  return useMutation(({ id }: { id: number }) => {
    return axios.delete(
      `${env.verifyServiceUrl}individual/portal_former_name/${id}/`,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
